export class TvHistoryMetadata {
    constructor(noData, nextTime = null) {
        this.noData = false;
        this.nextTime = null;
        this.noData = noData;
        this.nextTime = nextTime;
    }
}
